module.exports = __webpack_public_path__ + "img/3_uk.868433ef.svg";